// TestimonialsSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './../style/TestimonialsSection.module.scss';

import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

class TestimonialsSection extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRefPartners = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    if (this.swiperRefPartners.current && this.swiperRefPartners.current.swiper) {
      this.swiperRefPartners.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRefPartners.current && this.swiperRefPartners.current.swiper) {
      this.swiperRefPartners.current.swiper.slidePrev();
    }
  }

  render() {
    const { list } = this.props;

    return (
      <section className={styles.testimonialsSection}>
        <Container className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Компании, с которыми мы сотрудничаем</h2>
          </div>
          
          <div className={styles.sliderContainer}>
            <Swiper
              ref={this.swiperRefPartners}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={5}
              loop={true}
              autoHeight={false}
              observer={false}
              resizeObserver={false}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 3,
                  spaceBetween: 10
                },
                992: {
                  slidesPerView: 5,
                  spaceBetween: 10
                }
              }}
            >
              {list.map((el, k) => (
                <SwiperSlide key={k}>
                  {el?.href == `` ?
                    <Image src={el?.image} alt={el?.name} width={228} height={109} className={`w-100 h-auto`} />
                  :
                    <a className='w-100 d-block' href={el?.href} target="_blank">
                      <Image src={el?.image} alt={el?.name} width={228} height={109} className={`w-100 h-auto`} />
                    </a>
                  }
                </SwiperSlide>
              ))}
            </Swiper>

            <div className={styles.swiperControls}>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
                onClick={this.prevSlide}
              >
                <SwiperArrowLeft />
              </button>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonNext} ${styles.swiperButtonNextPartners}`}
                onClick={this.nextSlide}
              >
                <SwiperArrowRight />
              </button>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

TestimonialsSection.propTypes = {
  list: PropTypes.array
};

TestimonialsSection.defaultProps = {
  list: []
};

export default TestimonialsSection;